module.exports = __webpack_public_path__ + "media/images/lb/648-6dc7bb15d162a1cab24f5ae240578a08.svg";